import React, { useState, useContext, useEffect } from 'react';
import ModuleHeaderLayout from '../../components/Common/Layouts/ModuleHeaderLayout';
import { GlobalContext } from '../../providers/GlobalProvider';
import Entities from '../../components/Screening/mainTabComponents/Entities';
import Commodities from '../../components/Screening/mainTabComponents/Commodities';
import Cyber from '../../components/Screening/mainTabComponents/Cyber';
import FullRecord from './FullRecord';
import DataSearchAPI from '../../api/DataSearch';
import { Modal } from '@mui/material';
import PaymentsAPI from 'api/PaymentsAPI';


const Screening: React.FC = (props: any) => {
  const savedTab = window.sessionStorage.getItem('screeningTab');
  const [ screeningTab, setScreeningTab ] = useState<string>('');
  const [ entFilters, setEntFilters ] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [ comListFilters, setComListFilters ] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [ comCodeFilters, setComCodeFilters ] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [ showFullRecord, setShowFullRecord ] = useState({
    show: false,
    record: {},
  });
  const [ showFilters, setShowFilters ] = useState(true);

  // stripe
  const [ userHasEntitySearch, setUserHasEntitySearch ] = useState(false);
  const [ userHasCommoditySearch, setUserHasCommoditySearch ] = useState(false);
  const [ userHasCyberSearch, setUserHasCyberSearch ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');
  const [ activeEntitySub, setActiveEntitySub ] = useState(false);
  const [ activeCommoditySub, setActiveCommoditySub ] = useState(false);
  const [ activeCyberSub, setActiveCyberSub ] = useState(false);
  const [ screeningCus, setScreeningCus ] = useState({ isLoading: true, data: '' });

  const { cur_user } = useContext(GlobalContext);

  // inputs
  const [ entityInputs, setEntityInputs ] = useState<any>(
    {
      primary: '',
      country: '',
      address: '',
    },
  );
  const [ commodityInputs, setCommodityInputs ] = useState<any>(
    {
      hsCode: '',
      desc: '',
      origin: '',
      destination: ''
    },
  );

  const [ tariffInputs, setTariffInputs ] = useState<any>(
    {
      htsCode: '',
      originCountry: '',
    },
  );
  const [ cyberInputs, setCyberInputs ] = useState<any>(
    {
      cyber: '',
    },
  );
  const [ entityPage, setEntityPage ] = useState<number>(0);
  const [ commodityPage, setCommodityPage ] = useState<number>(0);
  const [ cyberPage, setCyberPage ] = useState<number>(0);

  const [ entityState, setEntityState ] = useState({
    fuzzy: true,
    date: null,
    dateRange: [],
    lenses: [],
    countries: [],
    agencies: [],
    lists: [],
  });

  const [ commodityState, setCommodityState ] = useState({
    fuzzy: true,
    date: null,
    dateRange: [],
    comLenses: [],
    comFilters: [],
    chapters: [],
    sections: [],
    codes: [],
    countries: [],
    agencies: [],
    lists: [],
    hsCodeLists: [],
  });

  const handleTabSwitch = (newTab: string) => {
    switch (newTab) {
    case 'Entities':
      setScreeningTab('Entities');
      window.sessionStorage.setItem('screeningTab', 'Entities');
      break;
    case 'Commodities':
      setScreeningTab('Commodities');
      window.sessionStorage.setItem('screeningTab', 'Commodities');
      break;
    case 'Tariff':
      setScreeningTab('Tariff');
      window.sessionStorage.setItem('screeningTab', 'Tariff');
      break;
    case 'Cyber':
      setScreeningTab('Cyber');
      window.sessionStorage.setItem('screeningTab', 'Cyber');
      break;
    default:
      setScreeningTab('Entities');
    }
  };

  const checkForEntitySearch = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('standard') ||
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasEntitySearch(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Standard' ||
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveEntitySub(true);
            }
          });
        }
      });
    }
  };

  const checkForCommoditySearch = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasCommoditySearch(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveCommoditySub(true);
            }
          });
        }
      });
    }
  };

  const checkForCyberSearch = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro') ||
      cur_user.selected_team?.attributes?.tier?.includes('standard')
    ) {
      setUserHasCyberSearch(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveCyberSub(true);
            }
          });
        }
      });
    }
  };

  const getCusFromEmail = async() => {
    const res = await PaymentsAPI.getCustomerByEmail(
      cur_user.selected_team.attributes.team_admin[0]
    );
    if (res?.success) {
      res?.result?.data?.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setScreeningCus({ isLoading: false, data: cus });
        }
      });
    }
  };

  useEffect(() => {
    getCusFromEmail();
  }, []);

  useEffect(() => {
    checkForEntitySearch();
    checkForCommoditySearch();
    checkForCyberSearch();
  }, [ activeEntitySub, activeCommoditySub, activeCyberSub ]);

  useEffect(() => {
    if (props.location.state) {
      const { linkTab, primary, lenses } = props.location.state;
      setScreeningTab(linkTab);
      if (linkTab === 'Entities' && primary) {
        setEntityInputs(
          {
            primary: primary,
            country: '',
            address: '',
          }
        );
        if (lenses && lenses.length > 0) {
          setEntityState({ ...entityState, lenses: lenses });
        }
      }
      if (linkTab === 'Commodities' && primary) {
        setCommodityInputs(
          {
            hsCode: primary,
            desc: '',
            origin: '',
            destination: ''
          }
        );
        if (lenses && lenses.length > 0) {
          setCommodityState({ ...commodityState, comLenses: lenses });
        }
      }
      if (linkTab === 'Cyber' && primary) {
        setCyberInputs(
          {
            cyber: primary
          }
        );
      }
      window.sessionStorage.setItem('screeningTab', linkTab);
    } else if (savedTab) {
      setScreeningTab(savedTab);
    }
  }, [ props.location.state ]);

  const getFilters = async() => {
    const mongoReq = {
      query: {
        groupId: cur_user?.selected_team?.id,
        userId: cur_user?.basics?.id,
      },
    };
    const res = await DataSearchAPI.getUserSearchFilters(mongoReq);
    if (res?.success) {
      const entArr: any = [];
      const comListArr: any = [];
      const comCodeArr: any = [];

      res.result.forEach((filt: any) => {
        if (filt.type === 'entity') {
          entArr.push(filt);
        } else if (filt.type === 'commodityCode') {
          comCodeArr.push(filt);
        } else if (filt.type === 'commodityList') {
          comListArr.push(filt);
        }
      });
      setEntFilters({ isLoaded: true, arr: entArr });
      setComListFilters({ isLoaded: true, arr: comListArr });
      setComCodeFilters({ isLoaded: true, arr: comCodeArr });
    }
  };

  useEffect(() => {
    getFilters();
  }, []);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Quickly search for high risk people, companies and products as well as
      cyber threat indicators. Filter by Lens for more accuracy
    </p>
  );

  return (
    <ModuleHeaderLayout title='Screening' helpContent={helpContent}>
      <div className='screening-tabs-container'>
        <div className='screening-tabs-inner'>
          <div
            className={`screening-tab-btn${screeningTab === 'Entities' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Entities')}
          >
            <div
              className={`screening-tab-btn-text${screeningTab === 'Entities' ? '-selected' : ''
              }`}
            >
              People & Companies
            </div>
          </div>
          <div
            className={`screening-tab-btn${screeningTab === 'Commodities' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Commodities')}
          >
            <div
              className={`screening-tab-btn-text${screeningTab === 'Commodities' ? '-selected' : ''
              }`}
            >
              Import / Export Flags
            </div>
          </div>
          <div
            className={`screening-tab-btn${screeningTab === 'Cyber' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Cyber')}
          >
            <div
              className={`screening-tab-btn-text${screeningTab === 'Cyber' ? '-selected' : ''
              }`}
            >
              Cyber
            </div>
          </div>
        </div>
      </div>
      {screeningTab === 'Entities' && !screeningCus.isLoading && (
        <Entities
          screeningCus={screeningCus}
          activeSub={activeEntitySub}
          userHasEntitySearch={userHasEntitySearch}
          matchedTeamWithStripe={matchedTeamWithStripe}
          filters={entFilters}
          setFilters={setEntFilters}
          cur_user={cur_user}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          setShowFullRecord={setShowFullRecord}
          inputs={entityInputs}
          setInputs={setEntityInputs}
          page={entityPage}
          setPage={setEntityPage}
          entityState={entityState}
          setEntityState={setEntityState}
        />
      )}
      {screeningTab === 'Commodities' && !screeningCus.isLoading && (
        <Commodities
          screeningCus={screeningCus}
          activeSub={activeCommoditySub}
          userHasCommoditySearch={userHasCommoditySearch}
          matchedTeamWithStripe={matchedTeamWithStripe}
          cur_user={cur_user}
          setShowFullRecord={setShowFullRecord}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          inputs={commodityInputs}
          setInputs={setCommodityInputs}
          page={commodityPage}
          setPage={setCommodityPage}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          listFilters={comListFilters}
          setListFilters={setComListFilters}
          codeFilters={comCodeFilters}
          setCodeFilters={setComCodeFilters}
        />
      )}
      {screeningTab === 'Cyber' && (
        <Cyber
          activeSub={activeCyberSub}
          userHasCyberSearch={userHasCyberSearch}
          matchedTeamWithStripe={matchedTeamWithStripe}
          setShowFullRecord={setShowFullRecord}
          cur_user={cur_user}
          showFilters={showFilters}
          inputs={cyberInputs}
          setInputs={setCyberInputs}
          page={cyberPage}
          setPage={setCyberPage}
        />
      )}
      <Modal
        open={showFullRecord.show}
        onClose={() => setShowFullRecord({ show: false, record: {} })}
      >
        <FullRecord
          setShowFullRecord={setShowFullRecord}
          showFullRecord={showFullRecord}
        />
      </Modal>
    </ModuleHeaderLayout>
  );
};

export default Screening;
